import { createContext, useContext } from 'react';

export const ExportContext = createContext();

const callbackOutsideExportContextProvider = () => {
  console.error('useReportContext must be used within a ReportProvider');
};

export const useExportContext = () => {
  const context = useContext(ExportContext);

  if (!context) {
    // Return default values if no provider is found
    return {
      onPrint: callbackOutsideExportContextProvider,
      setPatient: () => ({}),
      setGridApi: () => ({}),
      setFooterProps: () => ({}),
      setTableData: () => ({}),
      setColumns: () => ({}),
      setHeaderConfigs: () => ({})
    };
  }

  return context;
};
